import { IconDownload } from "@tabler/icons-react";
import { Button } from "@/components/ui";
import { useExportarDocumentosCsv } from "../hooks/use-auditoria";

export function BotonExportDocumentosCsv({ top }: { top: number }) {
  const exportar = useExportarDocumentosCsv();
  return (
    <Button
      variant="default"
      size="xs"
      leftSection={<IconDownload size={12} />}
      loading={exportar.isPending}
      onClick={() => exportar.mutate({ top })}
    >
      Exportar CSV
    </Button>
  );
}
